import React from 'react';
import Head from 'next/head';
import NProgress from 'nprogress';
import Router from 'next/router';

Router.onRouteChangeStart = url => {
  NProgress.start();
};
Router.onRouteChangeComplete = () => NProgress.done();
Router.onRouteChangeError = () => NProgress.done();

const Header = ({ title = '' }) => {
  return (
    <Head>
      <title>{title}</title>
      <meta charSet="utf-8" />
      <meta name="keywords" content="Miss Once" />
      <meta name="description" content="Miss Once" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="format-detection" content="telephone=no" />
      <meta
        name="viewport"
        content="initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no"
      />
    </Head>
  );
};

export default Header;
